export default __webpack_public_path__ + "96340b5de50d8f6a617ca554b1f3cd24.png";